import React, { useState } from "react";
import './AskCallForm.css';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo_agroinsider_color from '../../assets/logo-agroinsider-color.svg';
import logo_consult_specialist from '../../assets/consultoria_especializada.svg';
import logo_footer_color from '../../assets/logos_footer_color.svg';
import LanguageSwitcher from "../../components/LanguageSwitcher/LanguageSwitcher";


function AskCallForm() {
    const navigate = useNavigate(); // Para navegação programática
    const { t } = useTranslation();
    const [formData, setFormData] = useState({
        nome: "",
        email: "",
        telefone: "",
        mensagem: "",
    });

    // Atualiza os dados do formulário
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const handleGoFirstPage = () => {
        navigate('/');
    }

    const validate = (nome, email, telefone, mensagem) => {
        
        if (nome) {
            if (nome.trim() && nome.trim().length < 3) {
                return false;
            }
        }
        if (email) {
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!regex.test(email)) {
                return false;
            }
        }
        if (telefone) {
            const regex = /^\+?\d{9,15}$/;
            if (!regex.test(telefone)) {
                return false;
            }
        }
        if (mensagem) {
            if (mensagem.trim() && mensagem.trim().length < 3) {
                return false;
            }
        }
        return true;
    }

    // Gerencia o envio do formulário
    const handleSubmit = async (e) => {
        e.preventDefault();

        const { nome, email, telefone, mensagem } = formData;

        if (!validate(nome, email, telefone, mensagem)) {
            alert("Por favor, preencha todos os campos obrigatórios!");
            return;
        }

        // try {
        //     await fetch(`${apiBase}co2message/${apiKey}`, {
        //         method: 'POST',
        //         body: JSON.stringify({
        //             name: nome,
        //             email: email,
        //             subject: "Consultar Especialista",
        //             country: "PT",
        //             phone: telefone,
        //             message: mensagem,
        //             languageCode: "pt-PT",
        //             creationSource: "Calculadora de Carbono"
        //         }),
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     });
        // } catch (e) {

        // }

        // alert("Formulário enviado com sucesso!");
        // console.log("Dados do formulário:", formData);

        // Reseta o formulário após o envio
        // setFormData({
        //     nome: "",
        //     email: "",
        //     telefone: "",
        //     mensagem: "",
        // });
    };

    return (
        <div className='form-background'>
            <div className='div-agroinsider-logo'>
                <img src={logo_agroinsider_color} alt="AgroInsider Logo" className="logo" />
            </div>
            <div className='div-page-logo'>
                <img className='img-page-logo' src={logo_consult_specialist} alt="AgroInsider Logo" />
            </div>
            <div className='farm-profile-description'>
                <span className='farm-profile-title'>{t('ConsultSpecialist.title')}</span>
                <span className='farm-profile-description-text'>{t('ConsultSpecialist.description')}</span>
            </div>
            <div className="form-profile-form">
                <div className="form-group">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group-specialist">
                            <input
                                type="text"
                                name="nome"
                                placeholder="Nome"
                                value={formData.nome}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group-specialist">
                            <input
                                type="email"
                                name="email"
                                placeholder="Email"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group-specialist">
                            <input
                                type="tel"
                                name="telefone"
                                placeholder="Número de Telefone"
                                value={formData.telefone}
                                onChange={handleChange}
                                required
                            />
                        </div>
                        <div className="form-group-specialist">
                            <textarea
                                name="mensagem"
                                placeholder="Mensagem"
                                value={formData.mensagem}
                                onChange={handleChange}
                                required
                            ></textarea>
                        </div>
                    </form>
                </div>
            </div>

            {/* Action Buttons */}
            <div className="form-group-buttons" style={{ flexDirection: "column", alignItems: "center" }}>
                <button className="form-next-button" onClick={(e) => handleSubmit(e)}>{t('ConsultSpecialist.submit')}</button>

                <button onClick={() => handleGoFirstPage()} className='initial-page-button'>
                    <span className='arrow-icon'>←</span>
                    <span>{t('initial_page')}</span>
                </button>
            </div>
            <LanguageSwitcher />
            <div className='div-logo-footer-color'>
                <img src={logo_footer_color} alt="AgroInsider Logo" className="logo" />
            </div>
        </div>
    );
}

export default AskCallForm;
